import {inject, IReactComponent} from 'mobx-react';
import {DashboardTopBar} from '../../../../../../dashboard/dashboard-top-bar';

const mapStoresToProps = (stores: any) => ({
    controller: stores.multipartyDashboardStore.liveTopBarController
});

export const TopBar = inject(mapStoresToProps)(DashboardTopBar) as IReactComponent;
